export default __webpack_public_path__ + "static/media/qr_driver_poster.11128563.png";